export default {
  action: {
    id: 'guest_orders_upgrade_block_cta',
    defaultMessage: 'Create account',
  },
}
